import { render, staticRenderFns } from "./ShopView.vue?vue&type=template&id=3a92db75&"
import script from "./ShopView.vue?vue&type=script&lang=ts&"
export * from "./ShopView.vue?vue&type=script&lang=ts&"
import style0 from "./ShopView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a92db75')) {
      api.createRecord('3a92db75', component.options)
    } else {
      api.reload('3a92db75', component.options)
    }
    module.hot.accept("./ShopView.vue?vue&type=template&id=3a92db75&", function () {
      api.rerender('3a92db75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShopView.vue"
export default component.exports